"use client";

import { type FC, useMemo } from "react";

import { geojsonRingToSvgPath } from "./geojson-to-svg";

interface PolygonPreviewProps {
  coordinates: number[][];
  size?: number;
  className?: string;
  fillColor?: string;
  strokeColor?: string;
  fillOpacity?: number;
  strokeOpacity?: number;
  strokeWidth?: number;
  swapLatLng?: boolean;
  useManualFit?: boolean;
}

const PADDING = 4;

export const PolygonPreview: FC<PolygonPreviewProps> = ({
  coordinates,
  size = 40,
  className,
  fillColor,
  strokeColor,
  fillOpacity,
  strokeOpacity,
  strokeWidth = 1.5,
  swapLatLng = false,
}) => {
  const pathD = useMemo(
    () =>
      geojsonRingToSvgPath(
        coordinates,
        size,
        size,
        PADDING,
        swapLatLng,
      ),
    [coordinates, size, swapLatLng],
  );

  if (!pathD) return null;

  const fill = fillColor ?? undefined;
  const stroke = strokeColor ?? fillColor ?? undefined;
  const useInlineColors = fill !== undefined || stroke !== undefined;

  return (
    <svg
      className={className}
      height={size}
      viewBox={`0 0 ${size} ${size}`}
      width={size}
    >
      <path
        className={!useInlineColors ? "fill-shape-fill-20 stroke-shape-border" : undefined}
        d={pathD}
        fill={fill}
        fillOpacity={fillOpacity}
        stroke={stroke}
        strokeLinejoin="round"
        strokeOpacity={strokeOpacity}
        strokeWidth={strokeWidth}
      />
    </svg>
  );
};

